export const FETCH_APPLICATION_GUIDES = 'guides/FETCH_APPLICATION_GUIDES';
export const FETCH_APPLICATION_GUIDES_SUCCESS = 'guides/FETCH_APPLICATION_GUIDES_SUCCESS';
export const FETCH_APPLICATION_GUIDES_ERROR = 'guides/FETCH_APPLICATION_GUIDES_ERROR';
export const SET_GUIDES_SEARCH_TERM = 'application/SET_GUIDES_SEARCH_TERM';

// Remove Guides
export const REMOVE_GUIDE = 'guides/REMOVE_GUIDE';
export const REMOVE_GUIDE_ERROR = 'guides/REMOVE_GUIDE_ERROR';
export const REMOVE_GUIDE_SUCCESS = 'guides/REMOVE_GUIDE_SUCCESS';

// Duplicate Guides
export const DUPLICATE_GUIDE = 'guides/DUPLICATE_GUIDE';
export const DUPLICATE_GUIDE_SUCCESS = 'guides/DUPLICATE_GUIDE_SUCCESS';
export const DUPLICATE_GUIDE_ERROR = 'guides/DUPLICATE_GUIDE_ERROR';

// Update Guide
export const UPDATE_GUIDE = 'guides/UPDATE_GUIDE';
export const UPDATE_GUIDE_SUCCESS = 'guides/UPDATE_GUIDE_SUCCESS';
export const UPDATE_GUIDE_ERROR = 'guides/UPDATE_GUIDE_ERROR';

// Edit Guide Host
export const EDIT_GUIDE_HOST = 'guides/EDIT_GUIDE_HOST';
export const EDIT_GUIDE_HOST_SUCCESS = 'guides/EDIT_GUIDE_HOST_SUCCESS';
export const EDIT_GUIDE_HOST_ERROR = 'guides/EDIT_GUIDE_HOST_ERROR';

// Create Guide
export const CREATE_GUIDE = 'guides/CREATE_GUIDE';
export const CREATE_GUIDE_SUCCESS = 'guides/CREATE_GUIDE_SUCCESS';
export const CREATE_GUIDE_ERROR = 'guides/CREATE_GUIDE_ERROR';

// Update Tour
export const UPDATE_TOUR = 'guides/UPDATE_TOUR';
export const UPDATE_TOUR_SUCCESS = 'guides/UPDATE_TOUR_SUCCESS';
export const UPDATE_TOUR_FAIL = 'guides/UPDATE_TOUR_FAIL';

// Fetch guide rules
export const FETCH_GUIDE_RULES = 'guides/FETCH_GUIDE_RULES';
export const FETCH_GUIDE_RULES_SUCCESS = 'guides/FETCH_GUIDE_RULES_SUCCESS';
export const FETCH_GUIDE_RULES_ERROR = 'guides/FETCH_GUIDE_RULES_ERROR';

// Update guide rules
export const UPDATE_GUIDE_RULES = 'guides/UPDATE_GUIDE_RULES';
export const UPDATE_GUIDE_RULES_SUCCESS = 'guides/UPDATE_GUIDE_RULES_SUCCESS';
export const UPDATE_GUIDE_RULES_ERROR = 'guides/UPDATE_GUIDE_RULES_ERROR';

// Fetch attribute for rule
export const FETCH_ATTRIBUTES_FOR_RULE_REQUEST = 'guides/FETCH_ATTRIBUTES_FOR_RULE_REQUEST';
export const FETCH_ATTRIBUTES_FOR_RULE_SUCCESS = 'guides/FETCH_ATTRIBUTES_FOR_RULE_SUCCESS';
export const FETCH_ATTRIBUTES_FOR_RULE_ERROR = 'guides/FETCH_ATTRIBUTES_FOR_RULE_ERROR';

// Fetch context (RLL) options for Adopt rule options
export const FETCH_CONTEXT_OPTIONS_FOR_RULE_REQUEST = 'guides/FETCH_CONTEXT_OPTIONS_FOR_RULE_REQUEST';
export const FETCH_CONTEXT_OPTIONS_FOR_RULE_SUCCESS = 'guides/FETCH_CONTEXT_OPTIONS_FOR_RULE_SUCCESS';
export const FETCH_CONTEXT_OPTIONS_FOR_RULE_ERROR = 'guides/FETCH_CONTEXT_OPTIONS_FOR_RULE_ERROR';
